export const PLACEHOLDER_OPTIONS: Map<string, string> =
  new Map([
    ["{{organisation}}", $localize`Organisation name`],
    ["{{employee_first_name}}", $localize`Employee's first name`],
    ["{{employee_last_name}}", $localize`Employee's last name`],
    ["{{manager_first_name}}", $localize`Manager's first name`],
    ["{{manager_last_name}}", $localize`Manager's last name`],
    ["{{user_first_name}}", $localize`User's first name`],
    ["{{user_last_name}}", $localize`User's last name`],
    ["{{requester_first_name}}", $localize`Requester's first name`],
    ["{{requester_last_name}}", $localize`Requester's last name`],
    ["{{cut_off_date}}", $localize`The date when no further data for the pulse request is collected`],
    ["{{sender_first_name}}", $localize`Sender's first name`],
    ["{{sender_last_name}}", $localize`Sender's last name`],
  ]);
